<template>
	<div class="wrapper" style="background: none">
		<dash-header></dash-header>
		<sidebar></sidebar>
		<div class="content-wrapper p-3">
			<div class="content-header">
				<div class="container-fluid">
				<div class="row mb-2">
					<div class="col-12">
						<div v-if="status && dataakun.identity_file == null" class="alert alert-warning alert-dismissible fade show" role="alert">
							<strong>Your identity card is empty!</strong> Please upload your identity card.
							<button type="button" class="close" data-dismiss="alert" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<h1 class="m-2" style="font-weight: bold; font-size: 35px">
							Profile
						</h1>
					<div class="row">
						<div class="col-lg-4">
						<div class="card card__profile p-3">
							<div class="card-profile__body">
							<img class="images_profile" src="../assets/image/default_profile.svg" />
							<!-- <img class="images_profile" :src="dataakun.image" /> -->
							<div class="card-profile__text">
								<h2 class="card-profile__text-name">
								{{dataakun.username}}
								</h2>
								<p class="card-profile__text mb-0">Profiling Risk :</p>
								<div class="card-profile__text-code mb-2">
									<div class="row">
										<div class="col-md-12" v-if="dataakun.profiling_risk_level == null">
											<router-link to="/profiling" class="btn btn_outline_red btn-sm profiling_btn">Complete Your Profiling</router-link>
										</div>
										<div class="col-md-12" v-else>
											<span class="badge badge-danger" v-if="dataakun.profiling_risk_level == 3">{{dataakun.profiling_risk_level_display ? dataakun.profiling_risk_level_display : '-'}}</span>
											<span class="badge badge-warning" v-else-if="dataakun.profiling_risk_level == 2">{{dataakun.profiling_risk_level_display ? dataakun.profiling_risk_level_display : '-'}}</span>
											<span class="badge badge-success" v-else>{{dataakun.profiling_risk_level_display ? dataakun.profiling_risk_level_display : '-'}}</span>
										</div>
									</div>
								</div>

								<p class="card-profile__text-code">Referral code :</p>
								<div class="card-profile__preferral-code">
									<div class="text-success text-left" v-if="copySukses">
										Referral code copied successfully!
									</div>
								<div class="d-flex align-items-center justify-content-between">
									<p class="card-profile__text-code-preview text-center" v-on:focus="$event.target.select()" ref="myinput" id="first">
										{{dataakun.referral_code ? dataakun.referral_code : '-'}}
									</p>
									<div class="button" v-if="dataakun.referral_code !== null">
										<button id="first-button" class="btn btn-sm btn__primary me-2" style="right:0;" @click.stop.prevent="copyTestingCode" title="Copy Code">Copy</button>
										<button type="button" @click="copyLink(dataakun.referral_code)" class="btn btn-sm btn__primary">
											<i class="bi bi-link-45deg me-2"></i>
											<span v-if="!copied">Copy Link</span>
											<span v-if="copied">Link Copied!!</span>
										</button>
									</div>
									<input type="hidden" id="testing-code" :value="dataakun.referral_code">
								</div>
								</div>
							</div>
							</div>
						</div>
						</div>
						<div class="col-lg-8">
						<div class="card card__profile">
							<div class="card-body p3">
							<div class="card-profile__identify">
							
							<router-link to="/profile/edit" :class="{'':dataakun.profile_verified_at == null}" class="btn btn-outline-warning float-right" role="button" aria-disabled="true" v-if="dataakun.profile_verified_at == null">
								Update Profile
							</router-link>

							<button v-else type="button" class="btn btn-outline-warning float-right" data-toggle="modal" data-target="#verifiedInfo">
								Update Profile
							</button>
								<p class="identify__label">Name</p>
								<p class="identify__value">{{dataakun.name}}</p>
								<p class="identify__label">Email</p>
								<p class="identify__value">{{dataakun.email}}</p>
								<div class="d-inline-block">
									<p class="identify__label">Phone</p>
									<p class="identify__value">{{dataakun.phone ? dataakun.phone : '-'}}</p>
								</div>
								<p class="identify__label">Date of Birth</p>
								<p class="identify__value">{{dataakun.dob ? dataakun.dob : '-'}}</p>
								<!-- <div class="d-inline-block ml-5">
								<p class="identify__label">Phone</p>
								<p class="identify__value">{{dataakun.phone ? dataakun.phone : '-'}}</p>
								</div> -->
								<p class="identify__label">Password</p>
								<div class="d-flex align-items-center">
									<p class="identify__value mr-4">
										************
									</p>
									<router-link to="/profile/change-password" class="btn btn-outline-dark">
										Change Password
									</router-link>
								</div>
							</div>
							</div>
						</div>
						</div>
						<div class="col-12">
						<div class="card card__profile">
							<div class="card-body">
							<div class="row">
								<div class="col-6">
								<p class="identify__label">Country</p>
								<p class="identify__value" v-if="dataakun.country == 'null'">-</p>
								<p class="identify__value" v-else>{{dataakun.country ? dataakun.country : "-"}}</p>
								<p class="identify__label">City</p>
								<p class="identify__value" v-if="dataakun.city == 'null'">-</p>
								<p class="identify__value" v-else>{{dataakun.city ? dataakun.city : '-'}}</p>
								<p class="identify__label">Address</p>
								<p class="identify__value" v-if="dataakun.address == 'null'">-</p>
								<p class="identify__value" v-else>{{dataakun.address ? dataakun.address : "-"}}</p>
								
								</div>
								<div class="col-6">
								<p class="identify__label">Identity Document Type</p>
								<p class="identify__value" v-if="dataakun.identity_type == 'ID_CARD'">ID CARD</p>
								<p class="identify__value" v-else-if="dataakun.identity_type == 'DRIVING_LICENSE'">DRIVING LICENSE</p>
								<p class="identify__value" v-else>{{dataakun.identity_type ? dataakun.identity_type : '-'}}</p>
								<p class="identify__label">
									Identity Number
								</p>
								<p class="identify__value">{{dataakun.identity_number ? dataakun.identity_number : '-'}}</p>
								<div class="row" v-if="dataakun.profile_verified_at == null">
									<div class="col-sm-6">
										<p class="identify__label">Identity Document</p>
										
										<a :href="dataakun.identity_file" target="_blank" class="identify__value">
											<svg id="file_download_icon" xmlns="http://www.w3.org/2000/svg" width="13.473" height="16" viewBox="0 0 13.473 16">
                                                <path id="Icon_material-insert-drive-file" data-name="Icon material-insert-drive-file" d="M7.486,3A1.5,1.5,0,0,0,6.007,4.519L6,16.675a1.5,1.5,0,0,0,1.479,1.519H16.4a1.507,1.507,0,0,0,1.486-1.519V7.558L13.431,3Z" transform="translate(-6 -3)" fill="#1b1b1b" opacity="0.5"/>
                                                <path id="Path_329" data-name="Path 329" d="M0,0,4.558,4.558H1.013A1.013,1.013,0,0,1,0,3.545Z" transform="translate(7.381 0)" fill="#1b1b1b"/>
                                                <path id="Icon_awesome-long-arrow-alt-down" data-name="Icon awesome-long-arrow-alt-down" d="M4.647,9.936V6.69a.271.271,0,0,0-.271-.271H3.112a.271.271,0,0,0-.271.271V9.936H1.8a.542.542,0,0,0-.383.925L3.361,12.8a.542.542,0,0,0,.766,0L6.07,10.861a.542.542,0,0,0-.383-.925Z" transform="translate(7.243 3.037)" fill="#1b1b1b"/>
                                            </svg>
										</a>
										<!-- <p class="identify__value">
											<img :src="dataakun.identity_file" class="id_image" alt="">
										</p> -->
									</div>
									<div class="col-sm-6">
										<p class="identify__label">Comparison File</p>
										<a :href="dataakun.comparison_file" target="_blank" class="identify__value">
											<svg id="file_download_icon" xmlns="http://www.w3.org/2000/svg" width="13.473" height="16" viewBox="0 0 13.473 16">
                                                <path id="Icon_material-insert-drive-file" data-name="Icon material-insert-drive-file" d="M7.486,3A1.5,1.5,0,0,0,6.007,4.519L6,16.675a1.5,1.5,0,0,0,1.479,1.519H16.4a1.507,1.507,0,0,0,1.486-1.519V7.558L13.431,3Z" transform="translate(-6 -3)" fill="#1b1b1b" opacity="0.5"/>
                                                <path id="Path_329" data-name="Path 329" d="M0,0,4.558,4.558H1.013A1.013,1.013,0,0,1,0,3.545Z" transform="translate(7.381 0)" fill="#1b1b1b"/>
                                                <path id="Icon_awesome-long-arrow-alt-down" data-name="Icon awesome-long-arrow-alt-down" d="M4.647,9.936V6.69a.271.271,0,0,0-.271-.271H3.112a.271.271,0,0,0-.271.271V9.936H1.8a.542.542,0,0,0-.383.925L3.361,12.8a.542.542,0,0,0,.766,0L6.07,10.861a.542.542,0,0,0-.383-.925Z" transform="translate(7.243 3.037)" fill="#1b1b1b"/>
                                            </svg>
										</a>
										<!-- <p class="identify__value">
											<img :src="dataakun.comparison_file" class="id_image" alt="">
										</p> -->
									</div>
								</div>
								<!-- <p class="identify__label">Identity Document (Back)</p>
								<p class="identify__value"><i class="fas fa-paperclip"></i> IdentityCard.jpg</p> -->
								<template v-if="dataakun.profile_verified_at == null">
								<p class="identify__label">Selfie Image with Identity Card</p>
								<a :href="dataakun.selfie_image" target="_blank" class="identify__value">
									<svg id="file_download_icon" xmlns="http://www.w3.org/2000/svg" width="13.473" height="16" viewBox="0 0 13.473 16">
                                        <path id="Icon_material-insert-drive-file" data-name="Icon material-insert-drive-file" d="M7.486,3A1.5,1.5,0,0,0,6.007,4.519L6,16.675a1.5,1.5,0,0,0,1.479,1.519H16.4a1.507,1.507,0,0,0,1.486-1.519V7.558L13.431,3Z" transform="translate(-6 -3)" fill="#1b1b1b" opacity="0.5"/>
                                        <path id="Path_329" data-name="Path 329" d="M0,0,4.558,4.558H1.013A1.013,1.013,0,0,1,0,3.545Z" transform="translate(7.381 0)" fill="#1b1b1b"/>
                                        <path id="Icon_awesome-long-arrow-alt-down" data-name="Icon awesome-long-arrow-alt-down" d="M4.647,9.936V6.69a.271.271,0,0,0-.271-.271H3.112a.271.271,0,0,0-.271.271V9.936H1.8a.542.542,0,0,0-.383.925L3.361,12.8a.542.542,0,0,0,.766,0L6.07,10.861a.542.542,0,0,0-.383-.925Z" transform="translate(7.243 3.037)" fill="#1b1b1b"/>
                                    </svg>
								</a>
								</template>
								<!-- <p class="identify__value">
									<img :src="dataakun.selfie_image" class="id_image" alt="">
								</p> -->
								</div>
							</div>
							</div>
						</div>
						</div>
					</div>
					</div>
				</div>
				</div>
			</div>
			<!-- Modal -->
			<div class="modal fade" id="verifiedInfo" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered">
					<div class="modal-content">
						<div class="modal-body">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
							<div class="text-center my-5">
								<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="bi bi-info-circle text-info mb-3" viewBox="0 0 16 16">
									<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
									<path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
								</svg>
								<h6 class="">
									Your account has been verified. If you want to make changes, please contact the admin.
								</h6>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="staticBackdropLabel">Edit Profile</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div v-if="message" class="alert alert-success" role="alert">{{message.message}}</div>
					<form @submit.prevent="editProfile()">
						<div class="form-group">
							<label for="name">Name</label>
							<input type="text" v-model="datainvestor.name" class="form-control" id="name" name="name">
							<div v-if="message.name" class="text-danger">
								{{message.name[0]}}
							</div>
							<input type="hidden" v-model="datainvestor.id" class="form-control" id="id" name="id">
						</div>
						<div class="form-group">
							<label for="username">Username</label>
							<input type="text" v-model="datainvestor.username" class="form-control" id="username" name="username">
							<div v-if="message.username" class="text-danger">
								{{message.username[0]}}
							</div>
						</div>
						<div class="form-group">
							<label for="email">Email</label>
							<input type="email" v-model="datainvestor.email" class="form-control" id="email" name="email">
							<div v-if="message.email" class="text-danger">
								{{message.email[0]}}
							</div>
						</div>
						<div class="form-group">
							<label for="phone">Phone</label>
							<input type="tel" v-model="datainvestor.phone" class="form-control" id="phone" name="phone">
							<div v-if="message.phone" class="text-danger">
								{{message.phone[0]}}
							</div>
						</div>
						<div class="form-group">
							<label for="identity_number">Identity Number</label>
							<input type="text" v-model="datainvestor.identity_number" class="form-control" id="identity_number" name="identity_number">
							<div v-if="message.identity_number" class="text-danger">
								{{message.identity_number[0]}}
							</div>
						</div>
						<div class="form-group">
							<label for="identity_number">Identity Photo</label>
							<div class="custom-file">
								<input type="file" @change="onFileChange" accept="all" class="" name="identity_file" id="identity_file">
								<!-- <label class="custom-file-label" for="customFile">Choose file</label> -->
							</div>
							<div v-if="message.identity_file" class="text-danger">
								{{message.identity_file[0]}}
							</div>
						</div>
						<div class="form-group">
							<label for="identity_number">Selfie Image</label>
							<div class="custom-file">
								<input type="file" @change="onFileSelfieChange" accept="all" class="" name="selfie_image" id="selfie_image">
								<!-- <label class="custom-file-label" for="customFile">Choose file</label> -->
							</div>
							<div v-if="message.selfie_image" class="text-danger">
								{{message.selfie_image[0]}}
							</div>
						</div>
						<div class="form-group">
							<label for="identity_type">Identity type</label>
							<select v-model="datainvestor.identity_type" class="form-control" id="identity_type">
								<option selected disabled>Choose..</option>
								<option>ID_CARD</option>
								<option>SIM</option>
							</select>
							<div v-if="message.identity_type" class="text-danger">
								{{message.identity_type[0]}}
							</div>
						</div>
						<div class="form-group">
							<label for="dob">Date of Birth</label>
							<input type="date" v-model="datainvestor.dob" class="form-control" id="dob" name="dob" placeholder="yyyy-mm-dd" pattern="(?:19|20)\[0-9\]{2}-(?:(?:0\[1-9\]|1\[0-2\])-(?:0\[1-9\]|1\[0-9\]|2\[0-9\])|(?:(?!02)(?:0\[1-9\]|1\[0-2\])-(?:30))|(?:(?:0\[13578\]|1\[02\])-31))">
							<div v-if="message.dob" class="text-danger">
								{{message.dob[0]}}
							</div>
						</div>
						<div class="form-group">
							<label for="city">City</label>
							<input type="text" v-model="datainvestor.city" class="form-control" id="city" name="city">
							<div v-if="message.city" class="text-danger">
								{{message.city[0]}}
							</div>
						</div>
						<div class="form-group">
							<label for="country">Country</label>
							<input type="text" v-model="datainvestor.country" class="form-control" id="country" name="country">
							<div v-if="message.country" class="text-danger">
								{{message.country[0]}}
							</div>
						</div>
						<div class="form-group">
							<label for="address">Address</label>
							<textarea v-model="datainvestor.address" class="form-control" id="address" rows="3"></textarea>
							<div v-if="message.address" class="text-danger">
								{{message.address[0]}}
							</div>
						</div>
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
						<button type="submit" class="btn btn-danger" :disabled="loading">
							<span v-show="loading" class="spinner-border spinner-border-sm"></span>
							<span v-show="!loading">Save Change</span>
						</button>
					</form>
					</div>
				</div>
			</div>
			</div>
		<section class="content"></section>
		</div>
		<!-- <dash-footer></dash-footer> -->
	</div>
</template>
<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import axios from 'axios'
import jwt_decode from "jwt-decode"
// import $ from "jquery";
// import swal from "sweetalert";

export default {
	name: "Profile",
	components: {
		DashHeader,
		// DashFooter,
		Sidebar,
	},
	data(){
		return{
			dataakun: [],
			akunemail: '',
			message: '',
			loading: false,
			status: false,
			copySukses: false,
			imageName: '',
			nameFile: '',
			selfieImage: '',
			url: '',
			copied: false,
			datainvestor:{
				id:"",
				name:"",
				username:"",
				email:"",
				phone:"",
				identity_file:"",
				selfie_image:"",
				identity_number:"",
				identity_type:"",
				dob:"",
				city: "",
				country: "",
				address: "",
			}
		}
	},
	computed: {
		currentUser(){
			return this.$store.state.auth.user;
		}
	},
	async mounted() {
		if(!this.currentUser) {
			this.$router.push('/login');
		}
		
		var token = localStorage.getItem('access_token')
		var access_token = jwt_decode(token)
		const user_id = access_token.user_id
		if(!localStorage.getItem('user_id')){
			localStorage.setItem('user_id', user_id)
		}

		await axios.get(`investor/${localStorage.user_id}`)
		.then(result => {
			// console.log('Profile: ', result.data.data)
			this.dataakun = result.data.data
			this.akunemail = result.data.data.email
			this.status = true
			// if(result.data.data.profiling_risk_level == null)
			// {
			//   this.$router.push('profiling')
			// }
		}).catch(() => {
			// console.log('Error Profile: ', err.response)
		})
	},
	methods: {
		copyText(element) {
			var Text = document.getElementById(element).innerText;
			
			var button = document.getElementById(element + '-button');
			navigator.clipboard.writeText(Text).then(function() {
				var originalText = button.innerText;
				button.innerText = 'Copied!';
				setTimeout(function(){
					button.innerText = originalText;
				}, 750);
			}, function() {
				button.style.cssText = "background-color: var(--red);";
				button.innerText = 'Error';
			});
		},
		copyTestingCode(){
			let testingCodeToCopy = document.querySelector('#testing-code')
			testingCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
			testingCodeToCopy.select()

			try {
				// var successful = document.execCommand('copy');
				// var msg = successful ? 'successful' : 'unsuccessful';
				this.copySukses = true
				// console.log(msg)
				setTimeout(() => {
					this.copySukses = false
				}, 1000);
			} catch (err) {
				alert('Oops, unable to copy');
			}

			/* unselect the range */
			testingCodeToCopy.setAttribute('type', 'hidden')
			window.getSelection().removeAllRanges()
		},
		copyLink(value) {
            var dummy = document.createElement('input'),
                text = window.location.origin+process.env.VUE_APP_PUBLIC_PATH+'register?ref='+value;

            document.body.appendChild(dummy);
            dummy.value = text;
            dummy.select();
            document.execCommand('copy');
            document.body.removeChild(dummy);
            if (dummy.value !== '') {
                this.copied = true
                setTimeout(() => {
                    this.copied = false
                }, 1000)
            } else{
                this.copied = false
            }
        },
		onFileChange(e){
			const file = e.target.files[0]
			this.imageName = e.target.files[0]
			this.nameFile = file
			// console.log(this.nameFile)
		// $('#trade_report_data').css('background-image', 'url(' + Dataisi + ')');
		},
		onFileSelfieChange(e){
			// const file = e.target.files[0]
			this.selfieImage = e.target.files[0]
			// this.nameFile = file
			// console.log(this.selfieImage)
		// $('#trade_report_data').css('background-image', 'url(' + Dataisi + ')');
		},
		sendUser(dataakun) {
			this.datainvestor = dataakun;
			// console.log("Get Data Investor", this.datainvestor)
		},
		editProfile(){
			// console.log('Identity Photo: ', this.imageName)
			// console.log('Selfie Image: ', this.selfieImage)
			// if(this.akunemail == this.datainvestor){
				let data = new FormData()
				data.append('id', this.dataakun.id)
				data.append('name', this.datainvestor.name)
				data.append('username', this.datainvestor.username)
				data.append('email', this.datainvestor.email)
				data.append('phone', this.datainvestor.phone)
				if(this.datainvestor.identity_file != this.imageName){
					data.append('identity_file', this.imageName)
				}else if(this.datainvestor.identity_file != null){
					data.append('identity_file', this.imageName)
				}
				if(this.datainvestor.selfie_image != this.selfieImage){
					data.append('selfie_image', this.selfieImage)
				}else if(this.datainvestor.selfie_image != null){
					data.append('selfie_image', this.selfieImage)
				}
				data.append('identity_number', this.datainvestor.identity_number)
				data.append('identity_type', this.datainvestor.identity_type)
				data.append('dob', this.datainvestor.dob)
				data.append('city', this.datainvestor.city)
				data.append('country', this.datainvestor.country)
				data.append('address', this.datainvestor.address)

				axios.put(`investor/${this.dataakun.id}/`, data)
				.then((response) => {
					console.log(response);
					// if(response.data.data.status === 200) {
						this.loading = true
						setImmediate(() => this.message = response.data, 2000)
						// swal('Data edited successfully', 'Please re-check your data.', 'success', {
						// 	button: "OK"
						// })
						// this.$bvModal.hide('modal-edituser')
						// $(this.$refs.editModal).on("hidden.bs.modal")
						this.$router.push({ path: `/profile` })
						// window.location.reload()
						// return router.push({
							// name: 'Login'
						// })
					// } else {
					// 	this.loading = false
					// 	// validation.value = response.data.response
					// 	// console.log(validation);
					// }
				}).catch((error) => {
					this.loading = false
					this.message = error.response.data.data
					// console.log(error.response)
				})
			// }
		}
	}
};
</script>
<style scoped>
.modal .modal-body .form-group input.form-control{
	padding: 15px;
}
.card__profile {
	border-radius: 25px;
	width: 100%;
}
.card-profile__body {
	text-align: center;
}

.card-profile .profiling_btn{
	padding: 8px !important;
}
.id_image{
	height: 100px;
	width: auto;
}
.images_profile {
	width: 150px;
	height: 150px;
	object-fit: cover;
	border-radius: 50%;
	text-align: center;
}
.card-profile__text {
	text-align: left;
}
.card-profile__text-name {
	margin-top: 20px;
	font-size: 20px;
}
.card-profile__text-copy {
	text-align: right;
	font-weight: bold;
	text-decoration: none;
}
.card-profile__text-code-preview {
	text-align: center;
	font-weight: bold;
}
.card-profile__preferral-code {
	text-align: center;
	position: relative;
}
.card-profile__text-copy {
	position: absolute;
	right: 0;
	top: 0;
}
.identify__label {
	font-weight: bold;
	color: rgba(0, 0, 0, 0.6);
}
.identify__value {
	font-weight: bold;
	margin-top: -10px;
}
</style>